import { useCallback, useEffect, useState } from 'react';

type UseYandexMetrikaProps = {
  id?: string;
  isLoginSuccess?: boolean;
  isLogoutSuccess?: boolean;
};

export const useYandexMetrika = ({
  id,
  isLoginSuccess,
  isLogoutSuccess,
}: UseYandexMetrikaProps) => {
  const [isSSRState, setIsSSRState] = useState(true);

  useEffect(() => {
    setIsSSRState(false);
  }, []);

  const ym = !isSSRState && id && window?.ym;
  //ToDO If there are more goals, it will be possible to add a config and move them to separate functions
  const [authorizationGoal, setAuthorizationGoal] = useState(false);

  useEffect(() => {
    if (isLogoutSuccess && authorizationGoal) {
      setAuthorizationGoal(false);
    }
  }, [authorizationGoal, setAuthorizationGoal, isLogoutSuccess]);

  const goalCallback = useCallback(() => {
    setAuthorizationGoal(true);
  }, [setAuthorizationGoal]);

  useEffect(() => {
    if (ym && id && !authorizationGoal && isLoginSuccess) {
      ym(Number(id), 'reachGoal', 'Authorization', undefined, goalCallback);
    }
  }, [ym, id, authorizationGoal, goalCallback, isLoginSuccess]);
};
